import { GET_BANK_ACCOUNT_POCKET } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Root {
    success: boolean;
    response: Response[];
    error?: string;
}

export interface Response {
    id: string;
    entity: string;
    contact_id: string;
    account_type: string;
    bank_account?: BankAccount;
    batch_id?: string;
    active: boolean;
    created_at: number;
    validated_status: string;
    vpa?: Vpa;
    account_category?: string;
}

export interface BankAccount {
    ifsc: string;
    bank_name: string;
    name: string;
    notes: string[];
    account_number: string;
}

export interface Vpa {
    username: string;
    handle: string;
    address: string;
}

export const PRIMARY = 'Primary';

export default (isForDoctor?: boolean): Promise<Root> => {
    return fetchWithRefresh(GET_BANK_ACCOUNT_POCKET(isForDoctor)).then((res) => res.json());
};
